import React, { useEffect, useMemo } from "react";
// mui
import { Grid2 } from "@mui/material";
//styling
import styles from "./ManageSites.module.scss";
// local import
import SiteHeaderCard from "../../Sites/Components/HeaderComponent/Header";

export default function ManageSites() {
  return (
    <>
      <Grid2 className={styles.Container}>
        <Grid2 className={styles.header}>Sites</Grid2>
        <SiteHeaderCard
          name={"Nikhil Yada"}
          email={"Nikhilraj.yada@tekyantra.com"}
        />
      </Grid2>
    </>
  );
}
